module.exports = __webpack_public_path__ + "img/Picture14.07e0b8da.jpg";